import React, { useEffect } from 'react';
import classnames from 'classnames/bind';
import { connect } from 'react-redux';
import ContentLoader from 'react-content-loader';

import { getFireDB } from 'src/utils/Firebase';
import Room from './components/Room';
import css from './index.scss';
import { setRoomId, getRoomData } from 'src/redux/room/actions';

const cx = classnames.bind(css);
const moduleName = 'Rooms';

const RoomSkeleton = () => (
  <ContentLoader
    speed={1.5}
    width="100%"
    height={480}
    backgroundColor="#EDE7DC"
    foregroundColor="#F5F0E8"
  >
    <rect x="0" y="0" rx="0" ry="0" width="60%" height="480" />
    <rect x="65%" y="60" rx="2" ry="2" width="25%" height="16" />
    <rect x="65%" y="100" rx="2" ry="2" width="30%" height="28" />
    <rect x="65%" y="150" rx="2" ry="2" width="10%" height="3" />
    <rect x="65%" y="175" rx="2" ry="2" width="28%" height="12" />
    <rect x="65%" y="195" rx="2" ry="2" width="26%" height="12" />
    <rect x="65%" y="215" rx="2" ry="2" width="24%" height="12" />
    <rect x="65%" y="265" rx="2" ry="2" width="18%" height="36" />
  </ContentLoader>
);

const Rooms = ({ room, getRoomData }) => {
  useEffect(() => {
    getFireDB().then(res => {
      getRoomData(res.val().rooms);
    });
  }, []);

  const isLoading = Object.keys(room).length === 0 || !room.data;

  return (
    <div className={cx(moduleName)}>
      <div className={cx(`${moduleName}-header`)}>
        <div className={cx(`${moduleName}-header-wrapper`)} />
        <div className={cx(`${moduleName}-header-content`)}>
          <p className={cx(`${moduleName}-header-label`)}>Stay</p>
          <h2>객실 소개</h2>
          <h4>모든 객실에서 자연경관을 큰 창으로 즐기실 수 있습니다</h4>
        </div>
      </div>

      <div className={cx(`${moduleName}-list`)}>
        {isLoading ? (
          <React.Fragment>
            <RoomSkeleton />
            <RoomSkeleton />
          </React.Fragment>
        ) : (
          room.data.map((val, i) => (
            <Room
              key={val.id}
              id={val.id}
              folder={['a','b','c','d','e','f'][i] || 'a'}
              title={val.title}
              content={val.content}
              size={val.size}
              reverse={i % 2 !== 0}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default connect(
  ({ room }) => ({ room }),
  { setRoomId, getRoomData }
)(Rooms);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Rooms/index.js